"use client";

import {
  MenubarRadioGroup,
  MenubarRadioItem,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
  MapProjection,
} from "@oreme/ui";
import { useAtom } from "jotai";
import { mapProjectionAtom } from "@/store";
import { mapProjections } from "@/utils";
import type { ReactElement } from "react";
import { useMapLibre } from "@/hooks";
import { useTranslations } from "next-intl";

function SharedMenubarViewProjection() {
  const t = useTranslations("global.MenubarViewProjection");
  const { map } = useMapLibre();
  const [projection, setProjection] = useAtom(mapProjectionAtom);

  const handleVelueChange = (value: string): void => {
    setProjection(mapProjections.get(value) as MapProjection);
    if (map) map.setProjection({ type: value });
  };

  return (
    <MenubarSub>
      <MenubarSubTrigger>{t("title")}</MenubarSubTrigger>
      <MenubarSubContent>
        <MenubarRadioGroup
          value={projection.id}
          onValueChange={handleVelueChange}
        >
          {Array.from(mapProjections).map(([key, projection]): ReactElement => {
            return (
              <MenubarRadioItem key={key} value={projection.id}>
                {t(projection.id)}
              </MenubarRadioItem>
            );
          })}
        </MenubarRadioGroup>
      </MenubarSubContent>
    </MenubarSub>
  );
}

export { SharedMenubarViewProjection };
